<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-flex align-items-start justify-content-between p-15 p-sm-20 p-md-25 gap-3 flex-wrap">
            <div class="d-flex align-items-center flex-nowrap" v-if="enableAddPatient">
                <template v-if="storeEnabled">
                    <router-link to="/create-patient"
                        class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
                        {{ $t('cta.create_patient') }}
                        <i class="ph-bold ph-plus position-relative ms-5 fs-12"></i>
                    </router-link>
                </template>
            </div>
            <span v-else></span>
            <div class="d-flex flex-wrap flex-column gap-3 justify-content-end align-items-end ms-auto">

                <!-- CENTER FILTER -->
                <div class="card-select align-items-center d-inline-flex ms-auto" v-if="(centers?.length ?? 0) > 1">
                    <span class="fw-medium text-muted me-8">{{ $t('form.center_id.label') }}</span>
                    <select
                        class="form-select shadow-none text-black border-0 p-15 pe-50 bg-body-tertiary fs-14 fw-medium"
                        v-model="centerId" v-on:change="setFilter">
                        <option :value="-1" class="fw-medium">{{ $t('cta.show_all') }}</option>
                        <option v-for="center in centers" :key="center.id" :value="center.id" class="fw-medium">
                            {{ center.name }}
                        </option>
                    </select>
                </div>
                <div class="d-inline-flex flex-wrap jusify-content-end gap-3">
                    <!-- TEXT FILTER -->
                    <form class="search-box position-relative">
                        <input type="text" class="form-control shadow-none text-black rounded-0 border-0"
                            v-model="textQuery" :placeholder="$t('cta.search')" @keydown.enter="setFilter" />
                        <!-- <button type="submit" class="bg-transparent text-primary transition p-0 border-0 mt-0">
                        <i class="ph ph-magnifying-glass"></i>
                    </button> -->
                    </form>
                    <!-- EMAIL FILTER -->
                    <form class="search-box position-relative">
                        <input type="text" class="form-control shadow-none text-black rounded-0 border-0"
                            v-model="emailQuery" :placeholder="$t('form.email.label')" @keydown.enter="setFilter" />
                        <!-- <button type="submit" class="bg-transparent text-primary transition p-0 border-0 mt-0">
                        <i class="ph ph-magnifying-glass"></i>
                    </button> -->
                    </form>
                </div>
                <div class="d-flex gap-3 flex-row">
                    <button
                        class="bg-transparent text-muted transition p-0 border-0 mt-0 text-uppercase d-flex align-items-center gap-1"
                        v-if="filters" @click="clearFilters">
                        <i class="ph ph-x"></i><span class="fs-10">{{ $t('cta.clear_filters') }}</span>
                    </button>
                    <button @click="setFilter"
                        class="default-btn position-relative transition border-0 fw-medium text-white pt-10 pb-10 ps-10 pe-10 rounded-1 bg-success fs-13 d-inline-flex text-decoration-none gap-3 align-items-center">
                        {{ $t('cta.search') }}
                        <i class="ph ph-magnifying-glass fs-16"></i></button>
                </div>

            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <SpinnerLoading v-if="patients === undefined || patients === null" class="mt-50" />
            <div class="table-responsive" v-else>
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.last_name.label').toUpperCase() }}
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.first_name.label').toUpperCase() }}
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.center_id.label').toUpperCase() }}
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.birth_date.label').toUpperCase() }}
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.gender.label').toUpperCase() }}
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                {{ $t('form.created_at.label').toUpperCase() }}
                            </th>
                            <th scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                            </th>
                        </tr>
                    </thead>
                    <tbody class="linked">
                        <!-- PATIENT ROW -->
                        <tr v-for="patient in (patients! as PatientInfo[])" :key="patient!.id">
                            <th class="shadow-none lh-1 fw-medium text-black-emphasis title" @click="show(patient)">
                                {{ patient.lastname }}
                            </th>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis title" @click="show(patient)">
                                {{ patient.firstname }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis" @click="show(patient)">
                                <template v-if="!(((patientCenter(patient.center_id)?.is_custom_center ?? false) == true) || ((patient.self_registration ?? false) == true))">
                                    {{ patientCenter(patient.center_id)?.name ?? patient.center_id }}
                                </template>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-muted" @click="show(patient)">
                                <template  v-if="(patient.self_registration ?? false) == false">
                                    {{ patient.birthdate }}
                                </template>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-muted" @click="show(patient)">
                                <template v-if="(patient.self_registration ?? false) == false">
                                    {{ patient.sex != null ? $t(`form.gender.${patient.sex}`) : '' }}
                                </template>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-muted" @click="show(patient)">
                                <template v-if="(patient.self_registration ?? false) == false">
                                    {{ patient.created_at !== undefined ? formatDate(patient.created_at) : '' }}
                                </template>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end"
                                v-if="showActions(patient.center_id) || ((patient.self_registration ?? false) == true)">
                                <div class="dropdown position-static">
                                    <button
                                        class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                                        type="button" data-bs-toggle="dropdown" aria-expanded="false"
                                        data-bs-boundary="viewport">
                                        <i class="flaticon-dots"></i>
                                    </button>
                                    <ul class="dropdown-menu">
                                        <li v-if="centerPermission(patient.center_id, 'show') || ((patient.self_registration ?? false) == true)">
                                            <router-link :to="{ path: `/patient/${patient.id}` }"
                                                class="dropdown-item d-flex align-items-center">
                                                <i class="ph ph-eye lh-1 me-8 position-relative top-1"></i>
                                                {{ $t('cta.view') }}
                                            </router-link>
                                        </li>
                                        <li v-if="centerPermission(patient.center_id, 'update')">
                                            <router-link :to="{ path: `/patient/${patient.id}/edit` }"
                                                class="dropdown-item d-flex align-items-center">
                                                <i class="ph-duotone ph-pencil lh-1 me-8 position-relative top-1"></i>
                                                {{ $t('cta.edit') }}
                                            </router-link>
                                        </li>
                                        <li v-if="centerPermission(patient.center_id, 'destroy')">
                                            <button class="dropdown-item d-flex align-items-center"
                                                v-on:click="confirmDeletePatient(patient)">
                                                <i class="ph ph-trash lh-1 me-8 position-relative top-1"></i>
                                                {{ $t('cta.delete') }}
                                            </button>
                                        </li>
                                    </ul>

                                </div>
                            </td>
                        </tr>
                        <!--  -->
                    </tbody>
                </table>
            </div>
            <!-- PAGINATION -->
            <TablePagination :count="patients?.length ?? 0" :page="currentPage" :total="totalPatients" :pages="lastPage"
                @change="setPage($event)" />
        </div>
    </div>
    <ConfirmModal @confirm="deletePatient()" :title="$t('cta.$delete.title')" :message="$t('cta.$delete.message')" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ConfirmModal from "@/components/Widgets/ConfirmModal.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import { Modal } from "bootstrap";
import { CenterWithPermission, PatientInfo } from "@/utils/models/user.model";
import API from "@/services/api/api.service";
import DateFormatUtils from "@/utils/methods/date_formats";
import stateStore from "@/utils/store";
import { PermissionAction } from "@/utils/const/permission_actions";
import TablePagination from "@/components/FK/TablePagination.vue";

export default defineComponent({
    name: "PatientsList",
    props: {
        enableAddPatient: { type: Boolean, default: true }
    },
    data() {
        return {
            patients: undefined,
            currentPage: 1,
            totalPatients: 0,
            lastPage: 1,
            confirmModal: null,
            selectedPatient: null,
            pageSize: 0,
            centerId: this.$route.query.center_id ?? -1,
            centers: stateStore.getCentersWithPermisison('index'),
            emailQuery: this.$route.query.email,
            textQuery: this.$route.query.query,
        } as {
            patients?: PatientInfo[],
            currentPage: number,
            lastPage: number,
            pageSize: number,
            totalPatients: number,
            confirmModal: Modal | null,
            selectedPatient: PatientInfo | null;
            centerId: number;
            centers?: CenterWithPermission[],
            emailQuery?: string
            textQuery?: string
        }
    },
    mounted() {
        var queryIndex = parseInt(this.$route.query.page as string ?? '1');
        if (queryIndex > 0) {
            this.currentPage = queryIndex;
        }
        this.loadPatients(this.currentPage);
        this.confirmModal = new Modal('#confirmModal', {})
    },
    computed: {
        storeEnabled() { return stateStore.getPermisison('store') },
        center(): number | undefined {
            return this.centerId > 0 ? this.centerId : undefined;
        },
        filters(): boolean {
            return (this.center !== undefined && this.center !== -1) || (this.emailQuery !== undefined && this.emailQuery !== '') || (this.textQuery !== undefined && this.textQuery !== '');
        }
    },
    methods: {
        loadPatients(page: number) {
            this.patients = undefined;
            API.getPatients({ page: page, center_id: this.center, email: this.emailQuery, query: this.textQuery }).then((res) => {
                this.patients = res.data.data;
                this.totalPatients = res.data.total;
                this.lastPage = res.data.last_page;
                this.pageSize = res.data.per_page;
            })
        },
        setPage(page: number) {
            this.currentPage = page;
            this.$router.replace({ query: { page: this.currentPage, center_id: this.center, email: this.emailQuery, query: this.textQuery } });
            this.loadPatients(page);
        },
        confirmDeletePatient(patient: PatientInfo) {
            this.selectedPatient = patient;
            this.$data.confirmModal?.show();
        },
        deletePatient(): void {
            API.deletePatient(this.selectedPatient?.id!).then((response) => {
                if (response.data.success === true) {
                    this.selectedPatient = null;
                    this.setPage(1);
                }
            }).finally(() => {
                console.log("DELETED_PATIENT_ID", this.selectedPatient?.id);
            })
        },
        setFilter() {
            console.log(this.centerId);
            this.setPage(1);
        },
        formatDate(date: Date) {
            return DateFormatUtils.YYYYMMDD(date);
        },
        patientCenter(id: number): CenterWithPermission | undefined {
            return stateStore.getCenter(id);
        },
        centerPermission(center_id: number, action: PermissionAction): boolean { return stateStore.getCenterPermission(center_id, action); },
        showActions(center_id: number): boolean { return stateStore.getCenterPermission(center_id, 'show') || stateStore.getCenterPermission(center_id, 'update') || stateStore.getCenterPermission(center_id, 'destroy') },
        show(patient: PatientInfo) {
            if (this.centerPermission(patient.center_id, 'show') || patient.self_registration) {
                this.$router.push({ path: `/patient/${patient.id}` });
            }
        },
        queryEmail() {
            if (this.emailQuery === '') {
                this.emailQuery = undefined;
            }
            this.setPage(1);
        },
        queryText() {
            if (this.textQuery === '') {
                this.textQuery = undefined;
            }
            this.setPage(1);
        },
        clearFilters() {
            this.emailQuery = undefined;
            this.textQuery = undefined;
            this.centerId = -1;
            this.setPage(1);
        },
    },
    components: {
        ConfirmModal,
        SpinnerLoading,
        TablePagination
    },
});
</script>